export function combineForms(...forms) {
  forms = forms.filter(f => f);

  const fields = combine(forms, 'fields', { isArray: true });
  const labels = combine(forms, 'labels');
  const placeholders = combine(forms, 'placeholders');
  const types = combine(forms, 'types');
  const values = combine(forms, 'values');
  const validators = combine(forms, 'validators');
  const handlers = combine(forms, 'handlers', { mapSub: true });
  const extra = combine(forms, 'extra', { mapSub: true });
  const initials = combine(forms, 'initials');
  const output = combine(forms, 'output');
  const observers = combine(forms, 'observers');
  const interceptors = combine(forms, 'interceptors');

  return { fields, labels, placeholders, types, values, validators, handlers, extra, initials, output, observers, interceptors };
}

function combine(forms, field, { isArray, mapSub } = {}) {
  const data = forms.map(f => f[field]).filter(f => f);
  if (!data.length) { return undefined; }

  return isArray ? data.reduce((a, b) => a.concat(b), []) : (mapSub ? mapSubProps(data) : Object.assign({}, ...data));
}

function mapSubProps(data) {
  const toReturn = {};
  data.forEach(d => Object.keys(d).forEach(k => {
    toReturn[k] = Object.assign(toReturn[k] || {}, d[k]);
  }));
  return toReturn;
}